<!-- Copyright (C) 2022 by Posit Software, PBC. -->

<template>
  <div class="wizard-panel wizard-panel__publish-jupyter wizard-panel--white">
    <div class="wizard-panel__content">
      <StepHeading :step="step">
        Publish
      </StepHeading>
      <p>
        In the Jupyter toolbar, press the
        <span class="emphasize">Publish</span>
        button and follow the on-screen instructions.
      </p>
      <p>
        <img
          alt="rsconnect Publish button in Jupyter toolbar"
          src="./screenshot.png"
        >
      </p>

      <p>
        If you don't see the Publish button, the required
        rsconnect-jupyter plugin has not been correctly installed in your
        Jupyter environment.
      </p>

      <p class="wizard-panel__notice">
        <strong>Note:</strong>
        You must have a matching version of Python installed and configured
        on the {{ systemDisplayName }} server.
      </p>

      <ul class="publish-jupyter__links">
        <li class="publish-jupyter__link">
          <a
            :href="learnMoreLink"
            target="_blank"
          >
            Learn more about how to publish Jupyter Notebooks
          </a>
        </li>
        <li class="publish-jupyter__link">
          <a
            :href="troubleshootingLink"
            target="_blank"
          >
            Troubleshooting Python with Posit Connect
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { docsPath } from '@/utils/paths';
import StepHeading from '@/views/content/PublishWizard/StepHeading';
import PanelMixin from '../PanelMixin';

export default {
  name: 'PublishJupyter',
  components: { StepHeading },
  mixins: [PanelMixin],

  computed: {
    learnMoreLink() {
      return docsPath('user/jupyter-notebook');
    },
    troubleshootingLink() {
      return docsPath('user/troubleshooting');
    }
  },
};
</script>

<style lang="scss" scoped>
  .wizard-panel .publish-jupyter {
    &__links {
      margin-top: 1rem;
    }

    &__link {
      margin-bottom: 0.5rem;
    }
  }
</style>
